import Select from "react-select";
import { useEffect, useState } from "react";
import { useSettings } from "context/SettingsContext"
import { useTheme } from "context/ThemeContext";
import { selectStylesDark, selectStylesLigth } from "utils/helpers/structs/selectStyles";
import InputLabel from "components/others/InputLabel";
import { useTranslation } from "react-i18next";
import { isTeamActive } from "utils/helpers/teams/isTeamActive";

const TeamSelect = ({
    value,
    isMulti = false,
    isClearable = false,
    showEmpty = false,
    onChange,
    disabled = false,
    hideLabel = false,
    placeholder = undefined,
    className = 'w-100',
}) => {

    const { t } = useTranslation();
    const { darkTheme } = useTheme();   
    const { localSettings, dispatchLocalSettings } = useSettings();
    const [ selectTheme, setSelectTheme ] = useState(darkTheme?selectStylesDark:selectStylesLigth);
    const [ options, setOptions ] = useState([]);    

    useEffect(() => {
        setOptions(
            localSettings?.DIRS?.Team
                ?.filter(team => (showEmpty || team.ID) && isTeamActive(team))
                ?.map(team => ({ value: team.ID, label: team.teamName })) || []
        );
    }, [localSettings?.DIRS?.Team, showEmpty]);
 
    useEffect(()=>{
        setSelectTheme(darkTheme?selectStylesDark:selectStylesLigth);
    },[darkTheme])

    return (
        <InputLabel
            title={hideLabel ? '' : t('team')}>
            <Select options={options}
                  
                isDisabled={disabled}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                menuPosition="fixed"
                styles={{
                    ...selectTheme, // Зберігаємо існуючі стилі
                    control: (base, state) => ({
                    ...base,
                    ...(selectTheme.control ? selectTheme.control(base, state) : {}), 
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 2000,
                    }),
                }} 
                className={className}
                isClearable={isClearable}
                isMulti={isMulti}
                placeholder={placeholder}
                value={
                    isMulti 
                        ? options?.find(opt=>value?.include(opt.value))
                        : options?.find(opt=>opt.value == value) || null}
                onChange={onChange}/>
        </InputLabel>
    )
}

export default TeamSelect;